export * from './format';

/**
 * @desc 反转义字符
 * @param
 */
export function unescapeHtml(html: string) {
    if (typeof html !== 'string') {
        return '';
    }

    return html
        .replace(/&(m|n)dash;/g, '—')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '\\"')
        .replace(/&#x27;/g, "'")
        .replace(/&#x60;/g, '`')
        .replace(/&#x2f;/g, '/');
}

/**
 * @desc 转义字符
 * @param
 */
export function escapeHtml(html: string) {
    if (typeof html !== 'string') {
        return '';
    }

    // @ts-ignore
    return html.replace(/<|&|>|-|"|'|\//g, function (matches) {
        return {
            '<': '&lt;',
            '>': '&gt;',
            '&': '&amp;',
            '-': '&mdash;',
            '"': '&quot;',
            "'": '&#x27;',
            '`': '&#x60;',
            '/': '&#x2f;',
        }[matches];
    });
}

/**
 * pad0
 */
export function pad0(value: string | number) {
    return ('0' + value).substr(-2, 2);
}

/**
 * 合并换行符
 * @param str string
 * @returns string
 */
export const mergeWrap = (str: string) => {
    if (typeof str !== 'string') {
        return '';
    }
    return str
        .trim()
        .replace(/(\n){2,}/g, '\n')
        .replace(/(\r\n){2,}/g, '\r\n');
};

function getTextNodes(node: Node): Node[] {
    let textNodes: Node[] = [];

    if (!node) {
        return textNodes;
    }

    if (node.nodeType === Node.TEXT_NODE) {
        textNodes.push(node);
    } else {
        const children = node.childNodes;
        for (let i = 0; i < children.length; i++) {
            textNodes = textNodes.concat(getTextNodes(children[i]));
        }
    }

    return textNodes;
}

interface MarkWordOption {
    htmlTag?: string; // 已经被包裹的html标签
    toTag?: string; // 需要标记成的单词的html标签，默认 em
}

/**
 * 将一段文字中的某个单词标记出来
 * @param paragraph 需要标记的段落
 * @param word 需要标记的单词
 * @param option 其他可定制参数
 */
export function markWord(paragraph: HTMLElement, word: string, option: MarkWordOption = {}): void {
    const textNodes = getTextNodes(paragraph);
    if (!textNodes.length) {
        return;
    }
    const htmlTag = option.htmlTag;
    const toTag = option.toTag ? option.toTag : htmlTag ? htmlTag : 'em';
    const wordWithHtmlTag = htmlTag ? `<${htmlTag}>${word}</${htmlTag}>` : word;
    for (let i = 0; i < textNodes.length; i++) {
        const textNode = textNodes[i];
        if (textNode.nodeValue!.includes(wordWithHtmlTag)) {
            const parent = textNode.parentNode!;
            const words = textNode.nodeValue!.split(wordWithHtmlTag);

            parent.removeChild(textNode);

            for (let j = 0; j < words.length; j++) {
                if (j > 0) {
                    const mark = document.createElement(toTag);
                    mark.textContent = word;
                    parent.appendChild(mark);
                }
                parent.appendChild(document.createTextNode(words[j]));
            }

            break;
        }
    }
}
